module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-left-c1338f51.svg";